import React, { Component, useState, useRef } from "react";
import Dock from "react-dock";
import more_arrow from "../images/more_arrow.svg";
import location_flag_code from "../location_flag_code.json";
import info from "../images/info.svg";
import bookmark from "../images/bookmark.svg";
import bookmarkFill from "../images/bookmarkFill.svg";
import mail from "../images/mail.svg";
import phone from "../images/phone.svg";
import website from "../images/website.svg";
import globalFlag from "../flags/WWflags.png";
//#region Flags Import
import HK from "../flags/HKflags.png";
import GB from "../flags/GBflags.png";
import DK from "../flags/DKflags.png";
import NL from "../flags/NLflags.png";
import GE from "../flags/GEflags.png";
import FR from "../flags/FRflags.png";
import AU from "../flags/AUflags.png";
import IN from "../flags/INflags.png";
import IT from "../flags/ITflags.png";
import CA from "../flags/CAflags.png";
import SG from "../flags/SGflags.png";
import RU from "../flags/RUflags.png";
import MC from "../flags/MCflags.png";
import SE from "../flags/SEflags.png";
import US from "../flags/USflags.png";
import AE from "../flags/AEflags.png";
import CN from "../flags/CNflags.png";
import CH from "../flags/CHflags.png";
import BR from "../flags/BRflags.png";
import BE from "../flags/BEflags.png";
import IL from "../flags/ILflags.png";
import MY from "../flags/MYflags.png";
import HU from "../flags/HUflags.png";
import VN from "../flags/VNflags.png";
import CL from "../flags/CLflags.png";
import AT from "../flags/ATflags.png";
import DE from "../flags/DEflags.png";
import ES from "../flags/ESflags.png";
import KR from "../flags/KRflags.png";
import TR from "../flags/TRflags.png";
import { useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
//#endregion

let getFlag = (code) => {
  switch (code) {
    case "HK":
      return HK;
    case "GB":
      return GB;
    case "DK":
      return DK;
    case "NL":
      return NL;
    case "GE":
      return GE;
    case "FR":
      return FR;
    case "AU":
      return AU;
    case "IN":
      return IN;
    case "IT":
      return IT;
    case "CA":
      return CA;
    case "SG":
      return SG;
    case "RU":
      return RU;
    case "MC":
      return MC;
    case "SE":
      return SE;
    case "US":
      return US;
    case "AE":
      return AE;
    case "CN":
      return CN;
    case "CH":
      return CH;
    case "BR":
      return BR;
    case "BE":
      return BE;
    case "IL":
      return IL;
    case "MY":
      return MY;
    case "HU":
      return HU;
    case "VN":
      return VN;
    case "CL":
      return CL;
    case "AT":
      return AT;
    case "DE":
      return DE;
    case "ES":
      return ES;
    case "KR":
      return KR;
    case "TR":
      return TR;
  }
};

//#region Class version
class InformationCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      id: this.props.id,
      isVisible: false,
      name: this.props.name,
      location: this.props.location,
      headquarters: this.props.headquarters,
      type_tags: this.props.type_tags,
      sector_tags: this.props.sector_tags,
      contact_call: this.props.phone === "N/A" ? null : this.props.phone,
      contact_mail: this.props.mail === "N/A" ? null : this.props.mail,
      linked_in: this.props.linkedIn === "N/A" ? null : this.props.linkedIn,
      contact_website:
        this.props.contact_website === "N/A"
          ? null
          : this.props.contact_website,
      img_url: "https://www.w3schools.com/bootstrap4/img_avatar3.png",
      location_flag:
        "https://www.countryflags.io/" +
        this.props.location.trim().slice(-3, -1).toLowerCase() +
        "/flat/64.png",
      userData: {
        userBookmarks: [],
      },
      bookmarked: false,
      showList: false,
      bookmarkItem: this.props.bookmarkItem,
    };
    // this.getUserData();
  }

  componentDidMount() {}

  static getDerivedStateFromProps(props, state) {
    if (props.bookmarked !== state.bookmarked) {
      return {
        bookmarked: props.bookmarked,
      };
    }
    return null;
  }

  getUserData = async () => {};

  saveUserData = () => {};

  toggleBookMarks = (id, list) => {
    this.setState({ bookmarked: !this.state.bookmarked });
  };

  getTypeTags(k) {
    if (!this.state.type_tags) return <React.Fragment> </React.Fragment>;
    var filtered = this.state.type_tags.filter(function (el) {
      return el !== "";
    });
    if (k === -1) {
      k = filtered.length;
    }
    const firstk_tags = filtered
      .sort(function (a, b) {
        return a.length - b.length;
      })
      .slice(0, Math.min(k, filtered.length));

    var more = false;
    if (firstk_tags.length < filtered.length) {
      more = true;
    }

    return (
      <div style={{ margin: 0, marginLeft: "7px" }}>
        {firstk_tags.map((tag, idx) => (
          <span className="type-tags" key={idx}>
            {tag.length > 10 ? tag.slice(0, 8) + "..." : tag}
          </span>
        ))}
        {more ? (
          <span className="type-tags" key={more}>
            more<span className="more-type-circle"></span>
          </span>
        ) : (
          <span></span>
        )}
      </div>
    );
  }

  getSectorTags(k) {
    if (!this.state.sector_tags) return <React.Fragment> </React.Fragment>;
    var filtered = this.state.sector_tags.filter(function (el) {
      return el !== "";
    });
    if (k === -1) {
      k = filtered.length;
    }
    const firstk_tags = filtered
      .sort(function (a, b) {
        return a.length - b.length;
      })
      .slice(0, Math.min(k, filtered.length));

    var more = false;
    if (firstk_tags.length < filtered.length) {
      more = true;
    }
    if (firstk_tags.length === 0) {
      return;
    } else {
      return (
        <div>
          <p style={{ marginBottom: "0px" }}>Preferred Sector</p>
          <div style={{ margin: 0 }}>
            {firstk_tags.map((tag, idx) => (
              <span className="sector-tags" key={idx}>
                {tag}
              </span>
            ))}
            {more ? (
              <span className="sector-tags" key={more}>
                more<span className="more-sector-circle"></span>
              </span>
            ) : (
              <span></span>
            )}
          </div>
        </div>
      );
    }
  }

  getPhoneLink = () => {};

  getMailLink = () => {};

  getWebsiteLink = () => {};

  getLocation = () => {
    if (this.state.location === "N/A") {
      if (this.state.headquarters === "N/A") {
        return <React.Fragment></React.Fragment>;
      } else {
        return (
          <React.Fragment>
            <p>Headquarters</p>
            <div className="location-info">
              <span>
                <img src={US} className="flag-image" />
                {this.state.headquarters.split(",")[0]}
              </span>
            </div>
          </React.Fragment>
        );
      }
    } else if (this.state.location.split(",").length > 1) {
      return (
        <React.Fragment>
          <p>Location</p>
          <div className="location-info">
            <span>
              <img src={globalFlag} className="flag-image" />
              Multiple
            </span>
          </div>
        </React.Fragment>
      );
    } else {
      let code = location_flag_code[this.state.location];
      return (
        <React.Fragment>
          <p>Location</p>
          <div className="location-info">
            <span>
              <img src={getFlag(code)} className="flag-image" />
              {this.state.location}
            </span>
          </div>
        </React.Fragment>
      );
    }
  };

  render() {
    return (
      <div className="card-background">
        <div className="card-left">
          <div
            className="card-left-image-wrapper"
            onClick={() => this.setState({ isVisible: !this.state.isVisible })}
          >
            <center>
              <img className="card-left-img" src={this.state.img_url} />
            </center>
          </div>
          <div className="contact-details">
            {/* <center> */}
            {this.state.contact_call ? (
              <div className="phone-link contact-items">
                <img src={phone} className="contact-images" />
              </div>
            ) : (
              <React.Fragment></React.Fragment>
            )}

            {this.state.contact_mail ? (
              <div className="mail-link contact-items">
                <img src={mail} className="contact-images" />
              </div>
            ) : (
              <React.Fragment></React.Fragment>
            )}

            {this.state.contact_website ? (
              <div className="website-link contact-items">
                <img src={website} className="contact-images" />
              </div>
            ) : (
              <React.Fragment></React.Fragment>
            )}
            {/* </center> */}
          </div>
        </div>
        <div className="card-right">
          <div className="right-top">
            <span
              className="right-name"
              onClick={() =>
                this.setState({ isVisible: !this.state.isVisible })
              }
            >
              {this.state.name.length > 16
                ? this.state.name.slice(0, 16) + ".."
                : this.state.name}
              <span className="more-info-img-wrapper">
                <img src={info} className="more-info-img" />
              </span>
            </span>
            <img
              src={this.state.bookmarked ? bookmarkFill : bookmark}
              onClick={() =>
                this.state.bookmarkItem(this.state.id, this.state.bookmarked)
              }
              className="bookmark-image"
            />
          </div>
          <div
            className="right-mid"
            onClick={() => this.setState({ isVisible: !this.state.isVisible })}
          >
            <div className="right-mid-left">
              <p>Type</p>
              {this.getTypeTags(1)}
            </div>
            <div
              onClick={() =>
                this.setState({ isVisible: !this.state.isVisible })
              }
              className="right-mid-right"
            >
              {this.getLocation()}
            </div>
          </div>
          <div
            className="right-bottom"
            onClick={() => this.setState({ isVisible: !this.state.isVisible })}
          >
            {this.getSectorTags(2)}
          </div>
          <div
            className="more-arrow"
            onClick={() => this.setState({ isVisible: !this.state.isVisible })}
          >
            <img src={more_arrow} />
          </div>
        </div>

        <Dock
          position="bottom"
          fluid={true}
          size={0.8}
          dimStyle={{ background: "rgba(0, 0, 0, 0.9)" }}
          dockStyle={{ background: "rgba(20, 20, 20, 1)" }}
          isVisible={this.state.isVisible}
        >
          <div className="detail-page-overlay">
            <h1 className="detail-name">{this.state.name}</h1>
            <img src={this.state.img_url} className="detail-img" />
            <br></br>
            <span>Location : {this.state.location}</span>

            <br></br>
            <br></br>
            <div>Type :{this.getTypeTags(-1)}</div>
            <br></br>
            <div>{this.getSectorTags(-1)}</div>

            <div className="close-detail">
              <span onClick={() => this.setState({ isVisible: false })}>
                <i className="fa fa-times" style={{ color: "white" }}></i>
              </span>
            </div>
          </div>
        </Dock>
      </div>
    );
  }
}
//#endregion

function InvestorCard(props) {
  const {
    id,
    name,
    location,
    headquarters,
    contact_website,
    sectorTags,
    typeTags,
    stageTags,
    contact_call,
    linkedIn,
    contact_mail,
    bookmarkItem,
    img_url,
  } = props;
  const default_img_url =
    "https://www.w3schools.com/bootstrap4/img_avatar3.png";
  const [visible, setVisible] = useState(false);
  const [bookmarked, setBookmarked] = useState(false);
  const ref = useRef();
  const { currentUserData } = useAuth();

  const checkBookmark = () => {
    if (currentUserData !== null) {
      let flag = false;
      if ("userBookmarks" in currentUserData) {
        Object.keys(currentUserData.userBookmarks).forEach((list) => {
          if (
            id in currentUserData.userBookmarks[list] &&
            currentUserData.userBookmarks[list][id] === true
          ) {
            flag = true;
            setBookmarked(true);
          }
        });
      }
      if (!flag) setBookmarked(false);
    }
  };

  useEffect(() => {
    checkBookmark();
  }, [currentUserData]);

  useEffect(() => {
    checkBookmark();
  }, []);

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (visible && ref.current && !ref.current.contains(e.target)) {
        setVisible(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [visible]);

  const getTypeTags = (k) => {
    if (!typeTags) return <React.Fragment> </React.Fragment>;
    var filtered = typeTags.filter(function (el) {
      return el !== "";
    });
    if (k === -1) {
      k = filtered.length;
    }
    const firstk_tags = filtered
      .sort(function (a, b) {
        return a.length - b.length;
      })
      .slice(0, Math.min(k, filtered.length));

    var more = false;
    if (firstk_tags.length < filtered.length) {
      more = true;
    }
    if (firstk_tags.length === 0) {
      return;
    } else {
      return (
        <div>
          <p>Type</p>
          <div style={{ margin: 0, marginLeft: "7px" }}>
            {firstk_tags.map((tag, idx) => (
              <span className="type-tags" key={idx}>
                {tag.length > 10 ? tag.slice(0, 8) + "..." : tag}
              </span>
            ))}
            {more ? (
              <span className="type-tags" key={more}>
                more<span className="more-type-circle"></span>
              </span>
            ) : (
              <span></span>
            )}
          </div>
        </div>
      );
    }
  };

  const getSectorTags = (k) => {
    if (!sectorTags) return <React.Fragment> </React.Fragment>;
    var filtered = sectorTags.filter(function (el) {
      return el !== "";
    });
    if (k === -1) {
      k = filtered.length;
    }
    const firstk_tags = filtered
      .sort(function (a, b) {
        return a.length - b.length;
      })
      .slice(0, Math.min(k, filtered.length));

    var more = false;
    if (firstk_tags.length < filtered.length) {
      more = true;
    }
    if (firstk_tags.length === 0) {
      return;
    } else {
      return (
        <div>
          <p style={{ marginBottom: "0px" }}>Preferred Sector</p>
          <div style={{ margin: 0 }}>
            {firstk_tags.map((tag, idx) => (
              <span className="sector-tags" key={idx}>
                {tag.length > 10 ? tag.slice(0, 8) + "..." : tag}
              </span>
            ))}
            {more ? (
              <span className="sector-tags" key={more}>
                more<span className="more-sector-circle"></span>
              </span>
            ) : (
              <span></span>
            )}
          </div>
        </div>
      );
    }
  };

  const getAllTypeTags = () => {
    if (!typeTags) return <React.Fragment> </React.Fragment>;
    var filtered = typeTags.filter(function (el) {
      return el !== "";
    });
    if (filtered.length === 0) return;
    return (
      <div>
        <p style={{ marginBottom: "0px" }}>Type : </p>
        <span style={{ margin: 0, marginLeft: "7px" }}>
          {filtered.map((tag, idx) => (
            <span
              className="type-tags"
              style={{ width: "fit-content" }}
              key={idx}
            >
              {tag}
            </span>
          ))}
        </span>
      </div>
    );
  };

  const getAllSectorTags = () => {
    if (!sectorTags) return <React.Fragment> </React.Fragment>;
    var filtered = sectorTags.filter(function (el) {
      return el !== "";
    });
    if (filtered.length === 0) return;
    return (
      <div>
        <p style={{ marginBottom: "0px" }}>Preferred Sector : </p>
        <span style={{ margin: 0 }}>
          {filtered.map((tag, idx) => (
            <span className="sector-tags" key={idx}>
              {tag}
            </span>
          ))}
        </span>
      </div>
    );
  };

  const getAllStageTags = () => {
    if (!stageTags) return <React.Fragment> </React.Fragment>;
    var filtered = stageTags.filter(function (el) {
      return el !== "";
    });
    if (filtered.length === 0) return;
    return (
      <div>
        <p style={{ marginBottom: "0px" }}>Stage : </p>
        <span style={{ margin: 0 }}>
          {filtered.map((tag, idx) => (
            <span className="stage-tags" key={idx}>
              {tag}
            </span>
          ))}
        </span>
      </div>
    );
  };

  const getLocation = () => {
    if (location === "N/A") {
      if (!headquarters || headquarters === "N/A") {
        return <React.Fragment></React.Fragment>;
      } else {
        return (
          <React.Fragment>
            <p>Headquarters</p>
            <div className="location-info">
              <span>
                <img src={US} className="flag-image" />
                {headquarters.split(",")[0]}
              </span>
            </div>
          </React.Fragment>
        );
      }
    } else if (location.split(",").length > 1) {
      return (
        <React.Fragment>
          <p>Location</p>
          <div className="location-info">
            <span>
              <img src={globalFlag} className="flag-image" />
              Multiple
            </span>
          </div>
        </React.Fragment>
      );
    } else {
      let code = location_flag_code[location];
      return (
        <React.Fragment>
          <p>Location</p>
          <div className="location-info">
            <span>
              <img src={getFlag(code)} className="flag-image" />
              {location}
            </span>
          </div>
        </React.Fragment>
      );
    }
  };
  const getAllLocations = () => {
    if (location === "N/A") {
      if (!headquarters || headquarters === "N/A") {
        return <React.Fragment></React.Fragment>;
      } else {
        return (
          <React.Fragment>
            <div>Headquarters : </div>
            <div className="location-info">
              <span
                style={{
                  whiteSpace: "pre-wrap",
                }}
              >
                {"\t"}
                <img src={US} className="flag-image" />
                {headquarters}
              </span>
            </div>
          </React.Fragment>
        );
      }
    } else if (location.split(",").length > 1) {
      return (
        <React.Fragment>
          <div>Locations : </div>
          <div className="location-info">
            <span
              style={{
                whiteSpace: "pre-wrap",
              }}
            >
              {"\t"}
              <img src={globalFlag} className="flag-image" />
              {location.split(",").join("\n\t\t")}
            </span>
          </div>
        </React.Fragment>
      );
    } else {
      let code = location_flag_code[location];
      return (
        <React.Fragment>
          <div>Locations : </div>
          <div className="location-info">
            <span
              style={{
                whiteSpace: "pre-wrap",
              }}
            >
              {"\t"}
              <img src={getFlag(code)} className="flag-image" />
              {location}
            </span>
          </div>
        </React.Fragment>
      );
    }
  };

  return (
    <div className="card-background">
      <div className="card-left">
        <div
          className="card-left-image-wrapper"
          onClick={() => setVisible(!visible)}
        >
          <center>
            {img_url === "N/A" ? (
              <img className="card-left-img" src={default_img_url} />
            ) : (
              <img className="card-left-img" src={img_url} />
            )}
          </center>
        </div>
        <div className="contact-details">
          {contact_call && contact_call !== "N/A" ? (
            <div className="phone-link contact-items">
              <img src={phone} className="contact-images" />
            </div>
          ) : (
            <React.Fragment></React.Fragment>
          )}

          {contact_mail && contact_mail !== "N/A" ? (
            <div className="mail-link contact-items">
              <img src={mail} className="contact-images" />
            </div>
          ) : (
            <React.Fragment></React.Fragment>
          )}

          {contact_website && contact_website !== "N/A" ? (
            <div className="website-link contact-items">
              <img src={website} className="contact-images" />
            </div>
          ) : (
            <React.Fragment></React.Fragment>
          )}
        </div>
      </div>
      <div className="card-right">
        <div className="right-top">
          <span className="right-name" onClick={() => setVisible(!visible)}>
            {name.length > 16 ? name.slice(0, 16) + ".." : name}
            <span className="more-info-img-wrapper">
              <img src={info} className="more-info-img" />
            </span>
          </span>
          <img
            src={bookmarked ? bookmarkFill : bookmark}
            onClick={() => bookmarkItem(id, bookmarked, name)}
            className="bookmark-image"
          />
        </div>
        <div className="right-mid" onClick={() => setVisible(!visible)}>
          <div className="right-mid-left">{getTypeTags(1)}</div>
          <div onClick={() => setVisible(!visible)} className="right-mid-right">
            {getLocation()}
          </div>
        </div>
        <div className="right-bottom" onClick={() => setVisible(!visible)}>
          {getSectorTags(2)}
        </div>
        <div className="more-arrow" onClick={() => setVisible(!visible)}>
          <img src={more_arrow} />
        </div>
      </div>

      <Dock
        position="bottom"
        fluid={true}
        size={0.8}
        dimStyle={{ background: "rgba(0, 0, 0, 0.9)" }}
        dockStyle={{ background: "rgba(20, 20, 20, 1)" }}
        isVisible={visible}
      >
        <div style={{ width: "100%", height: "100%" }} ref={ref}>
          <div className="detail-page-overlay">
            <h1 className="detail-name">{name}</h1>
            {img_url === "N/A" ? (
              <img className="detail-card-img" src={default_img_url} />
            ) : (
              <img className="detail-card-img" src={img_url} />
            )}
            <br />
            <br />
            {contact_website && contact_website !== "N/A" ? (
              <div>
                Contact Website :{" "}
                <a href={contact_website} target="_blank">
                  {contact_website}
                </a>
              </div>
            ) : (
              ""
            )}
            {contact_mail && contact_mail !== "N/A" ? (
              <div>
                Contact Mail :{" "}
                <a href={"mailto:" + contact_mail} target="_blank">
                  {contact_mail}
                </a>
              </div>
            ) : (
              ""
            )}
            {contact_call && contact_call !== "N/A" ? (
              <div>
                Contact call :{" "}
                <a href={"tel:" + contact_call} target="_blank">
                  {contact_call}
                </a>
              </div>
            ) : (
              ""
            )}
            {linkedIn && linkedIn !== "N/A" ? (
              <div>
                LinkedIn :{" "}
                <a href={linkedIn} target="_blank">
                  {linkedIn}
                </a>
              </div>
            ) : (
              ""
            )}
            {getAllLocations()}
            <br />
            {typeTags ? <div>{getAllTypeTags()}</div> : ""}
            {sectorTags ? <div>{getAllSectorTags()}</div> : ""}
            {stageTags ? <div>{getAllStageTags()}</div> : ""}

            <div className="close-detail">
              <span onClick={() => setVisible(false)}>
                <i className="fa fa-times" style={{ color: "white" }}></i>
              </span>
            </div>
          </div>
        </div>
      </Dock>
    </div>
  );
}

InvestorCard.propTypes = {};

export default InvestorCard;
